import { useMediaQuery } from "native-base";
import { createContext, useContext, useEffect } from "react";
import { Dimensions, useWindowDimensions } from "react-native";

import { isNativeDevice } from "@/utils/platform";

type ViewportContextProps = {
  isWebMode: boolean;
  width: number;
  height: number;
};

const ViewportContext = createContext<ViewportContextProps>(null);

const BREAKPOINT = 998;

const initialWidth = Dimensions.get("window").width;

export const ViewportProvider = ({ children }) => {
  const { height, width } = useWindowDimensions();
  const [isWebMode] = useMediaQuery({
    minWidth: BREAKPOINT,
  });

  useEffect(() => {
    if (isNativeDevice) return;
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      if (initialWidth / window.width < 0 || initialWidth / window.width > 1) {
        location?.reload();
      }
    });
    return () => subscription?.remove();
  }, []);

  return (
    <ViewportContext.Provider value={{ isWebMode, height, width }}>
      {children}
    </ViewportContext.Provider>
  );
};

export const useViewport = () => useContext(ViewportContext);
